"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNavigationExperience = void 0;
var GlobalNavigationExperience;
(function (GlobalNavigationExperience) {
    GlobalNavigationExperience["DA"] = "da";
    GlobalNavigationExperience["DA_ONBOARD"] = "da-onboard";
    GlobalNavigationExperience["PA_ONBOARD"] = "pa-onboard";
    GlobalNavigationExperience["PAS_ONBOARD"] = "pas-onboard";
    GlobalNavigationExperience["INVEST_ONBOARD"] = "invest-onboard";
})(GlobalNavigationExperience = exports.GlobalNavigationExperience || (exports.GlobalNavigationExperience = {}));
